import { render, staticRenderFns } from "./MemberNew.vue?vue&type=template&id=5c1b5b7e&scoped=true&"
import script from "./MemberNew.vue?vue&type=script&lang=js&"
export * from "./MemberNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b5b7e",
  null
  
)

export default component.exports